module.exports = __webpack_public_path__ + "img/fleur.c2be1d68.png";